/**
 * 팝업 본문 마크다운 렌더.
 *
 * 어드민이 Toast UI 에디터로 작성한 마크다운 본문(이미지 포함)을 표시한다.
 * react-markdown 은 기본적으로 raw HTML 을 실행하지 않아(rehype-raw 미사용) XSS 안전하다.
 * 이미지는 팝업 폭을 넘지 않도록 max-w-full 로 제약한다. 기존 평문 본문도 그대로 렌더된다.
 */
import ReactMarkdown from 'react-markdown'

/** 마크다운 본문에서 첫 이미지 URL을 추출한다(배너 썸네일용). 없으면 null. */
export function firstMarkdownImage(md: string): string | null {
  const m = md.match(/!\[[^\]]*\]\(([^)\s]+)/)
  return m?.[1] ?? null
}

/** 배너처럼 한 줄 평문이 필요한 곳에서 마크다운 서식을 제거해 축약 표시한다. */
export function stripMarkdown(md: string): string {
  return md
    .replace(/!\[[^\]]*\]\([^)]*\)/g, '') // 이미지 제거
    .replace(/\[([^\]]*)\]\([^)]*\)/g, '$1') // 링크 → 텍스트
    .replace(/[*_~`#>]/g, '') // 강조·헤딩·인용·코드 기호
    .replace(/\s+/g, ' ') // 개행/다중공백 → 한 칸
    .trim()
}

export default function PopupMarkdown({
  children,
  className,
}: {
  children: string
  className?: string
}) {
  return (
    <div className={className}>
      <ReactMarkdown
        components={{
          img: ({ node: _node, ...props }) => (
            <img
              {...props}
              alt={props.alt ?? ''}
              loading="lazy"
              className="my-2 max-h-64 max-w-full rounded-lg object-contain"
            />
          ),
          a: ({ node: _node, ...props }) => (
            <a
              {...props}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline"
            />
          ),
          p: ({ node: _node, ...props }) => <p {...props} className="mb-1 last:mb-0 leading-relaxed" />,
          ul: ({ node: _node, ...props }) => <ul {...props} className="my-1 list-disc pl-5" />,
          ol: ({ node: _node, ...props }) => <ol {...props} className="my-1 list-decimal pl-5" />,
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  )
}
